import React from 'react';
import PropTypes from 'prop-types';

/**
 * VisuallyHidden — content that is visually hidden but read by screen readers.
 * Uses the global `.sr-only` utility defined in index.css.
 */
const VisuallyHidden = ({ as: Tag = 'span', children, className = '', ...rest }) => (
  <Tag className={`sr-only ${className}`.trim()} {...rest}>
    {children}
  </Tag>
);

VisuallyHidden.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default VisuallyHidden;
